import { render, staticRenderFns } from "./App.vue?vue&type=template&id=577c8f17&"
import script from "@/App.ts?vue&type=script&lang=ts&"
export * from "@/App.ts?vue&type=script&lang=ts&"
import style0 from "@/assets/scss/app.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports